import React, { useState } from "react";
import styles from "../commanstyles.module.css";
import { FaMinusSquare, FaPlusSquare } from "react-icons/fa";
import { IoMdLock } from "react-icons/io";
import { IoDocumentTextOutline } from "react-icons/io5";

function LegalHistory({ isSubScribe, data, Companyname }) {
  // Ensure data is defined and is an array
  const validLegalHistoryData = Array.isArray(data) ? data : [];

  // State to manage toggle for main sections
  const [toggleCasesFiledByCompany, setToggleCasesFiledByCompany] = useState(true);
  const [toggleCasesFiledAgainstCompany, setToggleCasesFiledAgainstCompany] = useState(true);
  const [toggleCasesForConsolidation, setToggleCasesForConsolidation] = useState(true);
  const [toggleCasesAsPerCIBIL, setToggleCasesAsPerCIBIL] = useState(true);

  const toggleSection = (section) => {
    if (section === "FiledByCompany") {
      setToggleCasesFiledByCompany(!toggleCasesFiledByCompany);
    } else if (section === "FiledAgainstCompany") {
      setToggleCasesFiledAgainstCompany(!toggleCasesFiledAgainstCompany);
    } else if (section === "ForConsolidation") {
      setToggleCasesForConsolidation(!toggleCasesForConsolidation);
    } else if (section === "AsPerCIBIL") {
      setToggleCasesAsPerCIBIL(!toggleCasesAsPerCIBIL);
    }
  };

  // Helper function to format dates as "12 Feb 2024"
  const formatDate = (date) => {
    const options = { year: "numeric", month: "short", day: "numeric" };
    const formattedDate = new Date(date).toLocaleDateString("en-GB", options);
    return formattedDate === "Invalid Date" ? "-" : formattedDate;
  };

  const renderTable = (subheading, tableHeaders, data, noDataMessage, Companyname) => (
    <div className={styles.tableContainer}>
      {isSubScribe ? (
        <>
          <div className={styles.highlet_header_content1}>
            <h3 className={styles.highlet_text}>{subheading}</h3>
          </div>
          <table className={styles.commantable}>
            <thead>
              <tr className={styles.tableHeaderRow}>
                {tableHeaders.map((header, index) => (
                  <th key={index} className={styles.tableHeader}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((row, index) => (
                  <tr key={row.id || index} className={styles.tableRow}>
                    {tableHeaders.map((header, idx) => {
                      // Render data dynamically based on header
                      if (header === "Respondent(s)") {
                        return (
                          <td key={idx} className={styles.tableCell}>
                            {row.respondent || "-"}
                          </td>
                        );
                      }
                      if (header === "Date of Last Hearing") {
                        return (
                          <td key={idx} className={styles.tableCell}>
                            {formatDate(row.date_of_last_hearing) || "-"}
                          </td>
                        );
                      }
                      if (header === "Date of Judgment") {
                        return (
                          <td key={idx} className={styles.tableCell}>
                            {formatDate(row.date_of_judgment) || "-"}
                          </td>
                        );
                      }
                      if (header === "Petitioner(s)") {
                        return (
                          <td key={idx} className={styles.tableCell}>
                            {row.petitioner || "-"}
                          </td>
                        );
                      }
                      if (header === "CIN") {
                        return (
                          <td key={idx} className={styles.tableCell}>
                            {row.CIN || "-"}
                          </td>
                        );
                      }
                      if (header === "Reference Document") {
                        return (
                          <td key={idx} className={styles.tableCell}>
                            {row.refDoc ? (
                              <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                                {/* Main File */}
                                {row.refDoc.fileurl && (
                                  <a
                                    href={row.refDoc.fileurl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title="View Main Document"
                                    style={{ display: "flex", alignItems: "center", textDecoration: "none", color: "#2961EF" }}
                                  >
                                    <IoDocumentTextOutline size={18} style={{ marginRight: "5px", flexShrink: 0 }} />
                                    <span style={{ wordBreak: "break-word" }}>
                                      {row.refDoc.MaiinFileName || row.refDoc.fileurl.split('/').pop()}
                                    </span>
                                  </a>
                                )}

                                {/* Attachments */}
                                {row.refDoc.Attachments && row.refDoc.Attachments.length > 0 && (
                                  <div style={{ display: "flex", flexDirection: "column", gap: "4px", marginLeft: "10px" }}>
                                    {row.refDoc.Attachments.map((att, aIdx) => (
                                      <a
                                        key={aIdx}
                                        href={att.fileurl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        title={att.Name}
                                        style={{ display: "flex", alignItems: "center", textDecoration: "none", color: "#2961EF", fontSize: "0.9em" }}
                                      >
                                        <IoDocumentTextOutline size={14} style={{ marginRight: "5px", flexShrink: 0 }} />
                                        <span style={{ wordBreak: "break-word" }}>{att.Name}</span>
                                      </a>
                                    ))}
                                  </div>
                                )}
                              </div>
                            ) : (
                              "-"
                            )}
                          </td>
                        );
                      }
                      return (
                        <td key={idx} className={styles.tableCell}>
                          {row[header.toLowerCase().replace(/\s+/g, "_")] || "-"}
                        </td>
                      );
                    })}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={tableHeaders.length} className={styles.noData}>
                    {noDataMessage}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </>
      ) : (
        <div className={styles.Subscription_msg}>
          <IoMdLock /> Subscription required to view data
        </div>
      )}
    </div>
  );

  return (
    <div>
      {/* Show lock button for non-subscribed users */}
      {!isSubScribe && (
        <div className={styles.Subscription_msg}>
          <IoMdLock /> Subscription required to view data
        </div>
      )}

      {isSubScribe && (
        <>
          {/* Section 1: Cases Filed by this Company */}
          <div className={styles.highlet_header_content1}>
            <p className={styles.minuse_icon} onClick={() => toggleSection("FiledByCompany")}>
              {toggleCasesFiledByCompany ? <FaMinusSquare size={22} /> : <FaPlusSquare size={22} />}
            </p>
            <h3 className={styles.highlet_text}>1. Cases Filed by this {Companyname && String(Companyname).toLowerCase()?.includes('LLP') ? 'LLP' : 'Company'}</h3>
          </div>
          {toggleCasesFiledByCompany && (
            <>
              {/* Table for Pending Cases - Filed by this Company */}
              {renderTable(
                "1.1 PENDING CASES",
                ["Case Category", "Case No", "Court", "Petitioner(s)", "Date of Last Hearing", "Reference Document"],
                validLegalHistoryData.filter(row => row.category === "pending cases" && row.case_category === "Cases Filed by this Company"),
                "As per our records, there are no pending cases."
              )}
              {/* Table for Disposed Cases - Filed by this Company */}
              {renderTable(
                "1.2 DISPOSED CASES",
                ["Case Category", "Case No", "Court", "Petitioner(s)", "Date of Judgment", "Reference Document"],
                validLegalHistoryData.filter(row => row.category === "disposed cases" && row.case_category === "Cases Filed by this Company"),
                "As per our records, there are no disposed cases."
              )}
            </>
          )}

          {/* Section 2: Cases Filed Against this Company */}
          <div className={styles.highlet_header_content1}>
            <p className={styles.minuse_icon} onClick={() => toggleSection("FiledAgainstCompany")}>
              {toggleCasesFiledAgainstCompany ? <FaMinusSquare size={22} /> : <FaPlusSquare size={22} />}
            </p>
            <h3 className={styles.highlet_text}>2. Cases Filed Against this Company</h3>
          </div>
          {toggleCasesFiledAgainstCompany && (
            <>
              {/* Table for Pending Cases - Filed Against this Company */}
              {renderTable(
                "2.1 PENDING CASES",
                ["Case Category", "Case No", "Court", "Respondent(s)", "Date of Last Hearing", "Reference Document"],
                validLegalHistoryData.filter(row => row.category === "pending cases" && row.case_category === "Cases Filed Against this Company"),
                "As per our records, there are no pending cases."
              )}
              {/* Table for Disposed Cases - Filed Against this Company */}
              {renderTable(
                "2.2 DISPOSED CASES",
                ["Case Category", "Case No", "Court", "Respondent(s)", "Date of Judgment", "Reference Document"],
                validLegalHistoryData.filter(row => row.category === "disposed cases" && row.case_category === "Cases Filed Against this Company"),
                "As per our records, there are no disposed cases."
              )}
            </>
          )}

          {/* Section 3: Cases for Consolidation of Companies */}
          <div className={styles.highlet_header_content1}>
            <p className={styles.minuse_icon} onClick={() => toggleSection("ForConsolidation")}>
              {toggleCasesForConsolidation ? <FaMinusSquare size={22} /> : <FaPlusSquare size={22} />}
            </p>
            <h3 className={styles.highlet_text}>3. Cases for Consolidation of Companies</h3>
          </div>
          {toggleCasesForConsolidation && (
            <>
              {/* Table for Pending Cases - For Consolidation */}
              {renderTable(
                "3.1 PENDING CASES",
                ["Case Category", "Case No", "Court", "Petitioner(s)", "Date of Last Hearing", "Reference Document"],
                validLegalHistoryData.filter(row => row.category === "pending cases" && row.case_category === "Cases for Consolidation of Companies"),
                "As per our records, there are no pending cases."
              )}
              {/* Table for Disposed Cases - For Consolidation */}
              {renderTable(
                "3.2 DISPOSED CASES",
                ["Case Category", "Case No", "Court", "Petitioner(s)", "Date of Judgment", "Reference Document"],
                validLegalHistoryData.filter(row => row.category === "disposed cases" && row.case_category === "Cases for Consolidation of Companies"),
                "As per our records, there are no disposed cases."
              )}
            </>
          )}

          {/* Section 4: Cases filed as per CIBIL */}
          <div className={styles.highlet_header_content1}>
            <p className={styles.minuse_icon} onClick={() => toggleSection("AsPerCIBIL")}>
              {toggleCasesAsPerCIBIL ? <FaMinusSquare size={22} /> : <FaPlusSquare size={22} />}
            </p>
            <h3 className={styles.highlet_text}>4. Other Cases</h3>
          </div>
          {toggleCasesAsPerCIBIL && (
            <>
              {/* Table for Pending Cases - As per CIBIL */}
              {renderTable(
                "4.1 PENDING CASES",
                ["Case Category", "Case No", "Court", "Petitioner(s)", "Date of Last Hearing", "Reference Document"],
                validLegalHistoryData.filter(row => row.category === "pending cases" && row.case_category === "Cases filed as per CIBIL"),
                "As per our records, there are no pending cases."
              )}
              {/* Table for Disposed Cases - As per CIBIL */}
              {renderTable(
                "4.2 DISPOSED CASES",
                ["Case Category", "Case No", "Court", "Petitioner(s)", "Date of Judgment", "Reference Document"],
                validLegalHistoryData.filter(row => row.category === "disposed cases" && row.case_category === "Cases filed as per CIBIL"),
                "As per our records, there are no disposed cases."
              )}
            </>
          )}
        </>
      )}
    </div>
  );
}

export default LegalHistory;
